import config from '@/config/index.js';

// http://showdoc.nevint.com/index.php?s=/lifestyle&page_id=19349
const decode = {
    url: `/api/2/in/lifestyle/account/user/decode`,
    method: 'get'
};

export default {
    decode
};



// WEBPACK FOOTER //
// ./src/service/common/code.js